import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import customParseFormat from "dayjs/plugin/customParseFormat";
/* add required plugin to dayjs */
export default defineNuxtPlugin(() => {
  dayjs.extend(isSameOrAfter);
  dayjs.extend(customParseFormat);
});
